import React from "react";
import warning from "../../assets/images/warning.png";
import { convertTo12Hour } from "../../utils/utils";

const AdditionalTimeEntryModal = (props) => {
  const { isOpen, closeModal, selectedUserEntry, selectedEquipmentEntry } =
    props;
  const tableHeading = ["Crew ID", "Project", "Start Time", "End Time"];
  return (
    isOpen && (
      <>
        <div
          className="modal show fade err-time-entry-modal"
          style={{ display: "block" }}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  <img src={warning} alt="warning" />
                  Additional time entries
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => closeModal()}
                ></button>
              </div>
              <div className="modal-body">
                {selectedUserEntry?.other_entries?.length > 0 && (
                  <>
                    <h2 className="heading">Team entries</h2>
                    <table className="table crew-modal-table table-striped">
                      <thead>
                        {tableHeading?.map((item, index, key) => (
                          <th
                            scope="col"
                            className={`table-heading text-start col-${index}`}
                            key={key}
                          >
                            {item}
                          </th>
                        ))}
                      </thead>
                      <tbody>
                        {selectedUserEntry?.other_entries?.map((ele, key) => {
                          return (
                            <tr key={key}>
                              {/* <td>
                                {ele?.employee_id || ele?.equipment_id || "NA"}
                              </td> */}
                              <td>{ele?.virtual_crew_id || "NA"}</td>
                              <td>{ele?.project || "NA"}</td>
                              <td>{convertTo12Hour(ele?.time_entry_in) || "NA"}</td>
                              <td>{convertTo12Hour(ele?.time_entry_out) || "NA"}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </>
                )}
                {selectedEquipmentEntry?.other_entries?.length > 0 && (
                  <>
                    <h2 className="heading">Equipment entries</h2>
                    <table className="table crew-modal-table table-striped">
                      <thead>
                        {tableHeading?.map((item, index, key) => (
                          <th
                            scope="col"
                            className={`table-heading text-start col-${index}`}
                            key={key}
                          >
                            {item}
                          </th>
                        ))}
                      </thead>
                      <tbody>
                        {selectedEquipmentEntry?.other_entries?.map((ele, key) => {
                          return (
                            <tr key={key}>
                              {/* <td>
                                {ele?.employee_id || ele?.equipment_id || "NA"}
                              </td> */}
                              <td>{ele?.virtual_crew_id || "NA"}</td>
                              <td>{ele?.project || "NA"}</td>
                              <td>{convertTo12Hour(ele?.time_entry_in) || "NA"}</td>
                              <td>{convertTo12Hour(ele?.time_entry_out) || "NA"}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </>
                )}
                {/* {failedEquipmentEntries?.length > 0 && (
                  <>
                    <h2 className="heading">Equipment entries</h2>
                    <table className="table crew-modal-table table-striped">
                      <thead>
                        {equipmentTableHeading?.map((item, index, key) => (
                          <th
                            scope="col"
                            className={`table-heading col-${index}`}
                            key={key}
                          >
                            {item}
                          </th>
                        ))}
                      </thead>
                      <tbody>
                        {failedEquipmentEntries?.length &&
                          failedEquipmentEntries?.map((ele, key) => {
                            return (
                              <tr key={key}>
                                <td>{ele?.equipment_id || "NA"}</td>
                                <td>{ele?.name || "NA"}</td>
                                <td>{ele?.crew_id || "NA"}</td>
                                <td>{ele?.time_entry_date || "NA"}</td>
                                <td>{ele?.time_entry_in || "NA"}</td>
                                <td>{ele?.time_entry_out || "NA"}</td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </>
                )} */}
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                  onClick={() => closeModal()}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    )
  );
};

export default AdditionalTimeEntryModal;
